import React from 'react';

import {
  CoreLink,
} from '../../../components';

const CallToActionCampaign = ({ entity }) => {

  const imageUrl = entity.getIn(['field_media', 0, 'styles', 'card'], null);
  const links = entity.get('field_links', []);

  return (
    <div className="CallToActionCampaign">
      {imageUrl && (
        <img src={imageUrl} alt="" />
      )}
      <br />

      {links.map((link) => {
        return (
          <>
            <CoreLink
              className="Button Button--primary Button--icon icon-after icon-before icon-arrow-right moving-arrow icon-variant-4"
              to={link.get('uri', '#')}
            >
              {link.get('title', '')}
            </CoreLink>
            <br />
          </>
        );
      })}

    </div>
  );
};

export default CallToActionCampaign;
